var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "OP950DocumentsWarehouseSiteWidget" },
    [
      _c(
        "v-layout",
        [
          _c("v-flex", { attrs: { xs6: "" } }, [
            _vm._v(
              _vm._s(_vm.$t("siteName")) + ": " + _vm._s(_vm.info.siteName)
            )
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs4: "" } }, [
            _vm._v(
              _vm._s(_vm.$t("authorizationId")) +
                ": " +
                _vm._s(_vm.info.authorizationId)
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-flex", { attrs: { xs6: "" } }, [
            _vm._v(_vm._s(_vm.$t("city")) + ": " + _vm._s(_vm.info.city))
          ]),
          _vm._v(" "),
          _c("v-flex", [
            _vm._v(
              _vm._s(_vm.$t("address")) + "1: " + _vm._s(_vm.info.address1)
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-flex", { attrs: { xs6: "" } }, [
            _vm._v(
              _vm._s(_vm.$t("state")) +
                ": " +
                _vm._s(_vm.abbrevToStates[_vm.info.state] || _vm.info.state)
            )
          ]),
          _vm._v(" "),
          _c("v-flex", [
            _vm._v(
              _vm._s(_vm.$t("zipCode")) +
                ": " +
                _vm._s(_vm.info.zipCode || _vm.info.zip)
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20fab609", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20fab609","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OP950DocumentsWarehouseSiteWidget.vue
// module id = null
// module chunks = 